import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Sparkles, Heart } from 'lucide-react';

export function AffirmationBridgeCTA() {
  return (
    <section className="py-16 md:py-24">
      <div className="container max-w-3xl mx-auto text-center">
        <motion.h2
          className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold billboard-flash mb-4 !leading-tight"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Now imagine creating one for someone who matters.
        </motion.h2>
        <motion.p
          className="text-base md:text-lg text-muted-foreground mb-10 max-w-xl mx-auto leading-relaxed"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          Start with yourself — then share something real.
        </motion.p>
        <motion.div
          className="flex flex-col sm:flex-row gap-3 justify-center"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <Link to="/affirmation-images">
            <Button size="lg" className="gap-2 rounded-xl shadow-lg shadow-primary/20">
              <Sparkles className="h-4 w-4" />
              Create Your Affirmation
            </Button>
          </Link>
          <Link to="/try">
            <Button size="lg" variant="outline" className="gap-2 rounded-xl">
              <Heart className="h-4 w-4" />
              Send a Message
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
